import {apiClient} from 'core/apiClient';
import {OrganizationListRequest, OrganizationPaginationContent, ProfileRole} from 'types/profile';

const URL = '/service/legal-identities';

export async function fetchOrganizationList(
    params: OrganizationListRequest,
): Promise<OrganizationPaginationContent> {
    return (
        await apiClient.post<OrganizationPaginationContent>('service/legal-identities', params, {
            baseURL: '/api/v2',
        })
    ).data;
}

type UpdateParticipantRolesPayload = {
    legalIdentityId: string | number;
    body: {
        rolesToAdd?: ProfileRole[];
        rolesToDeactivate?: ProfileRole[];
    };
};
export async function updateParticipantRoles(payload: UpdateParticipantRolesPayload) {
    return apiClient.put(`${URL}/${payload.legalIdentityId}/roles`, payload.body);
}

export type Organization = {
    legalIdentityId: number;
    legalName: string;
    shortName: string;
    taxIdNumber: string;
    legalAddress: string;
    country: string;
    postalCode: string;
    gln: string;
    vatId: string;
    gcp: string;
    bic: string;
    taxAuthName?: string;
    taxAuthCode?: string;
    director: {
        firstName: string;
        middleName: string;
        lastName: string;
        email: string;
        phone: string;
        role: string;
    };
    isBlocked: boolean;
    blockedAt: string;
    blockReason: string;
    blockedBy: string;
    unblockedAt: string;
    unblockReason: string;
    unblockedBy: string;
    iban: string;
};
export async function getOrganizationByTin(tin: string) {
    return (
        await apiClient.get<Organization>(`${URL}/${tin}`, {
            baseURL: '/api/v2',
        })
    ).data;
}

export async function blockOrganization(payload: {legalIdentityId: number; reason: string}) {
    return (await apiClient.post('/uaa/legal-identity/block', payload)).data;
}

export async function unblockOrganization(payload: {legalIdentityId: number; reason: string}) {
    return (await apiClient.post('/uaa/legal-identity/unblock', payload)).data;
}
